import { FC } from 'react';
import { IressText } from '@iress-oss/ids-components';
import { PlanSelection } from '../PlanSelection/PlanSelection';
import { RetirementFund } from '@xplan-pension-switching/common';

export const ScenarioModalContent: FC<{
    retirementFunds: Array<RetirementFund & { isSelected: boolean }>;
    hasFunds: boolean;
    onSelectionChanged: (retirementFundIds: number[]) => void;
    noFundsError: boolean;
}> = ({ retirementFunds, hasFunds, onSelectionChanged, noFundsError }) => {
    return hasFunds ? (
        <PlanSelection plans={retirementFunds} onSelectionChanged={onSelectionChanged} noFundsError={noFundsError} />
    ) : (
        <IressText data-testid={'no-plans-available'}>
            This client has no pensions on their record. To continue, please add a pension(s).
        </IressText>
    );
};
